// extracted by mini-css-extract-plugin
module.exports = {"prev":"pagination_prev__UmBIL","current":"pagination_current__1P51P","next":"pagination_next__2mpHO"};